import type { GraphQLFormattedError } from 'graphql';

type ZeusGraphQLError = Error & Pick<GraphQLFormattedError, 'extensions' | 'locations' | 'path'>;

export interface ZeusResult<TResult> {
  data: TResult | null;
  errors: readonly ZeusGraphQLError[];
}

interface RawZeusResult<TResult> {
  data?: TResult | null;
  errors?: readonly GraphQLFormattedError[];
}

export const normalizeZeusResult = <TResult>(
  response: RawZeusResult<TResult>,
): ZeusResult<TResult> => ({
  data: response.data ?? null,
  errors:
    response.errors?.map((error) =>
      // GraphQL response errors are plain JSON; observability clients need Error instances.
      Object.assign(new Error(error.message), {
        name: 'ZeusGraphQLError',
        extensions: error.extensions,
        locations: error.locations,
        path: error.path,
      }),
    ) ?? [],
});
